export class VirtualAccountBalanceModel {
  public generalBalance: number;

  public availableBalance: number;

  public toCollectBalance: number;

  constructor() {
    this.generalBalance = 0;
    this.availableBalance = 0;
    this.toCollectBalance = 0;
  }
}
